import { useEffect, useState, useMemo } from "react";
import { Card, CardContent, Typography, Box, Button, Drawer, TextField } from "@mui/material";
import { getAddOnMap } from "../../../../utils/services/APP/AddOn/getAddOnMap";
import PatientMapRosterTableAddOn from "./PatientMapComp/Table/PatientMapRosterTableAddOn";
import SpecialistReferralFormCodOpp from './PatientMapComp/SpecialistReferralFormCodOpp';

    
const AddOn = () => {
    const [selectedCenter, setSelectedCenter] = useState('All');
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [openReferralForm, setOpenReferralForm] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [AddOn, setAddOn] = useState({});
    const [allData, setAlldata] = useState({});

    const monthNames = [
        'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
    ];
    const handleAddPatient = (newPatient) => {
        setData(prev => {
            const exists = prev.some(patient => patient.id === newPatient.id);
            if (exists) {
            // Reemplazar el paciente existente por el nuevo
            return prev.map(patient =>
                patient.id === newPatient.id ? newPatient : patient
            );
            } else {
            // Agregar el nuevo paciente al final
            return [...prev, newPatient];
            }
        });
    };

    const handleSelectPatient = (patient) => {
        setSelectedPatient(patient);
        setOpenReferralForm(true)
    };

    const handleCreatePatient = () => {
        setSelectedPatient(null);
        setOpenReferralForm(true)
    };

    const[data,setData]=useState([])
    useEffect(() => {
        const Information = getAddOnMap();
        setData(Information.data);
        setAlldata(Information);
        FilterAddOn(Information.data);
    }, []);

    const FilterAddOn = (data) => {

        const countMap = {"All": data.length};

        data.forEach((item) => {
            const [day, month, year] = item.ServiceDate.split('/');
            const displayMonth = `${monthNames[parseInt(month, 10) - 1]}, ${year}`;

            if (!countMap[displayMonth]) {
            countMap[displayMonth] = 1;
            } else {
            countMap[displayMonth] += 1;
            }
        });

        setAddOn(countMap);
    };
    // const counts = useMemo(() => {
    //     const grouped = {};
    //     data.forEach(item => {
    //     grouped[item.medicalCenter] = (grouped[item.medicalCenter] || 0) + 1;
    //     });
    //     return grouped;
    // }, [data]);

    const filteredData = useMemo(() => {
        let filtered = selectedCenter === 'All'
            ? data
            : data.filter(item => {
                const [, month, year] = item.ServiceDate.split("/");
                const serviceDateFormatted = `${monthNames[parseInt(month, 10) - 1]}, ${year}`;
                return serviceDateFormatted === selectedCenter;
            });

        if (searchText.trim()) {
            filtered = filtered.filter(item =>
            item.PatientName.toLowerCase().includes(searchText.toLowerCase())
            );
        }
        return filtered;
    }, [selectedCenter, data, searchText]);
    
  return (
    <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
            Add On
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
            <TextField
                placeholder="Patient Name"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ width: '60%' }}
            />
            <Button variant="outlined" onClick={() => handleCreatePatient()} sx={{ ml: 2 }}>
                + Add
            </Button>
        </Box>
        <Box sx={{ borderBottom: '1px solid #ddd', mb: 2 }} />
        {/* Contenedor principal en fila */}
        <Box sx={{ display: 'flex', gap: 2 }}>
            
            {/* Sidebar */}
            <Box
                sx={{
                    width: 200,
                    pr: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }}
                >
                {Object.entries(AddOn).map(([key, value]) => (
                <Box
                    key={key}
                    onClick={() => setSelectedCenter(key)}
                    sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    backgroundColor: selectedCenter === key ? '#d1f2eb' : 'transparent',
                    borderRadius: '999px',
                    px: 2,
                    py: 0.5,
                    fontWeight: selectedCenter === key ? 'bold' : 'normal',
                    border: selectedCenter === key ? '1px solid #117a65' : 'none',
                    color: selectedCenter === key ? '#117a65' : 'inherit',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#d1f2eb',
                    },
                    }}
                >
                    {key}{' '}
                    <span style={{ color: '#aaa', marginLeft: 4 }}>
                    ({value || 0})
                    </span>
                </Box>
                ))}

            </Box>


            {/* Contenido principal con la tabla */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Card>
                    <CardContent sx={{ p: 0 }}>
                    <Box 
                        sx={{ 
                        height: 700, 
                        overflowY: "auto"
                        }}
                    >

                        <PatientMapRosterTableAddOn
                        data={filteredData}
                        loading={""}
                        total={allData.totalPages}
                        page={allData.page}
                        pageSize={allData.pageSize}
                        setPage={0}
                        setPageSize={0}
                        onSelectPatient={(p) => handleSelectPatient(p)}
                        />
                    </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>
        <Drawer anchor="right" open={openReferralForm} onClose={() => setOpenReferralForm(false)}>
            <Box width={650} p={3}>
                <SpecialistReferralFormCodOpp
                    modificar={ selectedPatient?? [] }
                    open={openReferralForm}
                    onClose={() => setOpenReferralForm(false)}
                    onSave={(newReferral) => {
                        handleAddPatient(newReferral);
                        setOpenReferralForm(false);
                    }}
                />
            </Box>
        </Drawer>
    </Box>
    
  );
};


export default AddOn;

